// Model.js
// -----------------------
// @module Case
define("BTM.GiftCertificatePatch.GiftCertificatePatch.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/GiftCertificatePatch/SuiteScript2/GiftCertificatePatch.Service.ss"
            ),
            true
        )
});
});
